<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <AdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <h4>Generate Excel Report</h4>

              <p style="margin:0;" class="border rounded text-center pt-2 pb-2">
                <span :style="{ colour: '#662D91' }"
                  >Note: Please select date range less than 6 months</span
                >
              </p>

              <b-form
                class="p-3 border rounded mt-3"
                @submit.prevent="submitData"
              >
                <div class="row">
                  <div class="col">
                    <label for="dateFrom" class="d-block">Date From:</label>
                    <!-- <b-form-input
                      type="date"
                      name=""
                      id="dateFrom"
                      v-model="DateFrom"
                    ></b-form-input> -->
                    <a-date-picker
                      style="width: 100%;"
                      format="MM/DD/YYYY"
                      :value="this.DateFrom"
                      @change="updateDateFrom"
                      id="dateFrom"
                    />
                  </div>

                  <div class="col">
                    <label for="dateTo">Date To:</label>
                    <!-- <b-form-input
                      type="date"
                      name=""
                      id="dateTo"
                      v-model="DateTo"
                    ></b-form-input> -->
                    <a-date-picker
                      style="width: 100%;"
                      :value="this.DateTo"
                      format="MM/DD/YYYY"
                      @change="updateDateTo"
                      id="dateTo"
                    />
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col">
                    <b-form-radio v-model="AllClients" :value="true">
                      <option value="">All Clients</option>
                      <p v-show="AllClients">
                        <span
                          v-for="client in getAuthorizedClients"
                          :key="+client.clientId"
                          >{{ client.clientName }} <br
                        /></span>
                      </p>
                    </b-form-radio>
                  </div>
                  <div class="col">
                    <b-form-radio v-model="AllClients" :value="false">
                      <option value="">Selected Clients</option>
                    </b-form-radio>

                    <b-form-select
                      multiple
                      class="p-2 mt-1"
                      v-model="SelectedClients"
                    >
                      <option
                        v-for="client in getAuthorizedClients"
                        :value="+client.clientId"
                        :key="+client.clientId"
                        >{{ client.clientName }}</option
                      >
                    </b-form-select>
                  </div>
                </div>

                <button class="btn btn-primary mt-4" type="submit">
                  Submit
                </button>
              </b-form>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import moment from "moment";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";

export default {
  name: "GenerateExcelReport",
  data() {
    return {
      DateFrom: moment().subtract(3, 'months'),
      DateTo: moment(),
      AllClients: false,
      SelectedClients: [],
    };
  },
  components: {
    AdminSidebar,
    Header,
    Footer,
  },
  watch: {
    SelectedClients(newVal) {
      if (newVal.length > 0) {
        this.AllClients = false;
      }
    },
    AllClients(newVal) {
      if (newVal) {
        console.log(newVal);
        this.SelectedClients = [];
      }
    },
  },
  computed: {
    getAuthorizedClients() {
      return this.$store.getters["clientBlogs/getAuthorizedClients"];
    },
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "reportsGenerateExcelReport",
        activeMenu: this.activeMenu ? this.activeMenu : "reports",
      });
    },
    submitData() {
      if (this.DateFrom === "" || this.DateTo === "") {
        alert("Please fill the dates field.");
        return;
      }

      let AllClientsArr = [];
      if (this.AllClients === true) {
        let AuthorizedClients = this.getAuthorizedClients;
        for (let client of AuthorizedClients) {
          AllClientsArr.push(+client.clientId);
        }
      } else {
        if (this.SelectedClients.length === 0) {
          alert("Please select atleast one client from the client list.");
          return;
        }
      }

      this.$store
        .dispatch("generateExcel/generateExcelFile", {
          start_date:
            moment(this.DateFrom).format("YYYY-MM-DD") + "T00:00:00.000Z",
          end_date: moment(this.DateTo).format("YYYY-MM-DD") + "T23:59:59Z",
          client_ids: this.AllClients ? AllClientsArr : this.SelectedClients,
        })
        .then(() => {
          this.$router.push({
            name: "GenerateExcelReportScreen",
          });
        });
    },
    updateDateFrom(date, datestring) {
      this.DateFrom = datestring;
    },
    updateDateTo(date, datestring) {
      this.DateTo = datestring;
    },
  },

  created() {
    this.setActiveMenuItem();

    this.$store.dispatch("clientBlogs/fetchAuthorizedClients");
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
